import queryString from 'query-string';
import callApi, { CallApiResult } from '.';

export const getCountries = (): Promise<CallApiResult> => {
    let query = queryString.stringify({ active: true }, { skipEmpty: true, skipNull: true });
    if (query !== '') query = '?' + query;

    return callApi(`/api/country/list${query}`);
};
